import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { LibraryAdd as AddSiteCardIcon } from '@material-ui/icons';

import { createSiteCardsFromFeatureAnalysesAsync } from '../../../../../redux/site_card/Actions';
import { ProjectDescription, Structure } from '../../../../../redux/project/projectTypes';
import MoveDialog from '../../../../Common/UI/Dialog/MoveDialog';

interface IProps {
    open: boolean;
    onClose: () => void;
    selectedFeatures: number[];
    projectStructure: Structure;
}

function AnalysisCreateDialog({ open, onClose, selectedFeatures, projectStructure }: IProps) {
    const [columnsArr, setColumnsArr] = useState<null | ProjectDescription[]>(null);
    const dispatch = useDispatch<any>();

    useEffect(() => {
        const columns = projectStructure.columnOrder.map(id => projectStructure.columns[id]);
        setColumnsArr(columns);
    }, [projectStructure]);

    function createSiteCard(dstColumn: number) {
        dispatch(createSiteCardsFromFeatureAnalysesAsync(selectedFeatures, dstColumn));
        onClose();
    }

    return (
        <MoveDialog
            open={open}
            onClose={onClose}
            title={'Create site cards'}
            icon={<AddSiteCardIcon />}
            onAction={createSiteCard}
            lists={columnsArr}
        />
    );
}

export default AnalysisCreateDialog;
